/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import baustein from "baustein";
import _ from "underscore";
import browser from "../utils/browser";
import analytics from "analytics/analytics";
import PaginatedCarousel from "components/paginated-carousel";

const MOBILE_SET = 1.3;
const TABLET_SET = 2.5;
const DESKTOP_SET = 3;
const GUTTER_WIDTH = 20;

const LYST_CARD_SELECTOR = ".content-card-portrait";
const CONTAINER_SELECTOR = ".lyst-cards-carousel__container";
const LYST_CARD_CAROUSEL_ENABLED_CLASS = "lyst-cards-carousel--carousel-enabled";

export default baustein.register("lyst-cards-carousel", {
    defaultOptions() {
        return {
            hasOnshowEvent: false
        };
    },

    setupEvents() {
        this.setGlobalHandler("resize", this._resize);
    },

    onInsert() {
        this._updateCarousel();

        if (this.options.hasOnshowEvent) {
            const eventCategory = this.el.getAttribute("event-category");
            const eventAction = this.el.getAttribute("event-action");
            const eventLabel = this.el.getAttribute("event-label");

            analytics.event(eventCategory, eventAction, eventLabel);
        }
    },

    /**
     * Recalculate the carousel options when the browser is resized
     */
    _resize: _.throttle(function() {
        this._updateCarousel();
    }, 100),

    /**
     * If it doesn't exist create a carousel else, update the carousel options
     */
    _updateCarousel() {
        const container = this.el.querySelector(CONTAINER_SELECTOR);
        if (!container) {
            return;
        }

        const [gutterWidth, itemsPerPage] = this._getItemLayout();
        const options = {
            items: Array.from(this.el.querySelectorAll(LYST_CARD_SELECTOR)),
            gutterWidth,
            itemsPerPage,
            eventCategory: "lyst-cards"
        };

        let paginatedCarousel = this.findComponent("paginated-carousel");
        if (paginatedCarousel) {
            paginatedCarousel.updateOptions(options);
        } else {
            paginatedCarousel = new PaginatedCarousel(options);
            paginatedCarousel.appendTo(container);
        }

        this.el.classList.add(LYST_CARD_CAROUSEL_ENABLED_CLASS);
    },

    /**
     * Identify how many items we want to show (based on viewport width) and the left
     * and right padding each item should have
     */
    _getItemLayout() {
        if (browser.getViewport() <= browser.VIEWPORTS.MOBILE) {
            return [GUTTER_WIDTH, MOBILE_SET];
        } else if (browser.getViewport() <= browser.VIEWPORTS.TABLET) {
            return [GUTTER_WIDTH, TABLET_SET];
        } else {
            return [GUTTER_WIDTH, DESKTOP_SET];
        }
    }
});

